var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-4",attrs:{"type":"warning","icon":_vm.meta.icon,"prominent":"","outlined":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }